// extracted by mini-css-extract-plugin
export default {"container":"s01_container__qXMdR","title":"s01_title__K3Yu2","desc":"s01_desc__s6I2u","fadeIn":"s01_fadeIn__c2XhM"};